import { render, staticRenderFns } from "./ShiftEditorPeriodicity.vue?vue&type=template&id=1da1953a&scoped=true&lang=pug&"
import script from "./ShiftEditorPeriodicity.vue?vue&type=script&lang=ts&"
export * from "./ShiftEditorPeriodicity.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftEditorPeriodicity.vue?vue&type=style&index=0&id=1da1953a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da1953a",
  null
  
)

export default component.exports